import type { ChecklistItem } from '@/screens/scan/types'

/** A selectable {value,label} pair shared by the Segmented and MultiSelect controls. */
export interface Option {
  value: string
  label: string
}

/** Distinct {value,label} options for a facet, derived from the loaded items. */
export function buildOptions(
  items: ChecklistItem[],
  pick: (item: ChecklistItem) => string[],
  label: (value: string) => string
): Option[] {
  const values = new Set<string>()
  for (const item of items) {
    for (const value of pick(item)) {
      if (value) values.add(value)
    }
  }
  return [...values].map((value) => ({ value, label: label(value) })).sort((a, b) => a.label.localeCompare(b.label))
}

// Mirrors ramp-web-app's Is Archived radio (No = active is the default scope).
export const ARCHIVED_OPTIONS: Option[] = [
  { value: 'all', label: 'All' },
  { value: 'archived', label: 'Yes' },
  { value: 'active', label: 'No' }
]

/** Partial / Exact — mirrors web FilterBar HASH_SET matchMode. */
export const MATCH_MODE_OPTIONS: Option[] = [
  { value: 'cn', label: 'Partial' },
  { value: 'in', label: 'Exact' }
]

/** Hardcoded Business Type options — mirrors web ChecklistItemSelectorDialog. */
export const BUSINESS_TYPE_OPTIONS: Option[] = [
  { value: 'PC', label: 'P&C' },
  { value: 'LAH', label: 'LAH' }
]
